module.exports = __webpack_public_path__ + "static/img/2.81ccca1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/zh/2.png
// module id = C1ph
// module chunks = 0